module.exports = __webpack_public_path__ + "static/ademuyiwa-260fb178873ee7005d4ecc52dda5db92.png";